import { render } from "./Home.vue?vue&type=template&id=28b456b4"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"
script.render = render

export default script